import { useCallback, useEffect } from "react";

import { Platform } from "../types";

interface UseIOSViewportOptions {
  platform: Platform;
}

interface UseIOSViewportResult {
  handleViewportResize: () => void;
}

export function useIOSViewport({ platform }: UseIOSViewportOptions): UseIOSViewportResult {
  const handleViewportResize = useCallback((): void => {
    const toolbar = document.querySelector(".rn-editor .editor-toolbar");
    if (!toolbar || !window.visualViewport) {
      return;
    }

    const toolbarWrapper = toolbar.parentElement;
    if (toolbarWrapper) {
      toolbarWrapper.style.top = `${window.visualViewport.pageTop}px`;
    }
  }, []);

  useEffect(() => {
    if (platform !== "ios") {
      return;
    }

    window.addEventListener("orientationchange", handleViewportResize);
    window.visualViewport?.addEventListener("resize", handleViewportResize);

    return () => {
      window.removeEventListener("orientationchange", handleViewportResize);
      window.visualViewport?.removeEventListener("resize", handleViewportResize);
    };
  }, [handleViewportResize, platform]);

  return { handleViewportResize };
}
